import { Model } from 'pinia-orm';
import { BelongsTo, MorphMany, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import Comment from './Comment';
import SharedFund from './SharedFund';

export default class SharedFundCost extends Model {
  static entity = 'App\\Models\\SharedFundCost';

  @Num(0)
  declare id: number;

  @Num(0)
  declare shared_fund_id: number;

  @Num(0)
  declare claim_id: number;

  @Num(undefined)
  declare current_claim: number | undefined;

  @Num(undefined)
  declare current_certified: number | undefined;

  @Str('')
  declare created_at: string | undefined;

  @Str('')
  declare updated_at: string | undefined;

  @BelongsTo(() => SharedFund, 'shared_fund_id', 'id')
  declare shared_fund: SharedFund;

  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;

  @MorphMany(() => Comment, 'commentable_id', 'commentable_type', 'id')
  declare comments: Comment[];

  get variance(): number {
    return (this.current_claim ?? 0) - (this.current_certified ?? 0);
  }
}
